import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl, defineMessages } from 'react-intl';

import { FILTER_PHOTOS_ONLY } from 'constants/filters';

import AssetFeed from 'components/assetFeed/AssetFeed';
import PickerFooter from './PickerFooter';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { v1URLsFromAsset } from 'helpers/asset-utils';

// #region icons and styled-components
const Container = styled.div`
  padding: var(--cc_size_spacing_l);
`;
const AssetFeedContainer = styled.div`
  padding: 0 var(--cc_size_spacing_xl);
`;
// #endregion

const messages = defineMessages({
  title: {
    id: 'ProjectPage.assetPicker.title',
    defaultMessage: 'Select Photos to Add',
    description: 'Title for the asset picker modal',
  },
});

const PageAssetPickerModal = ({
  editor,
  isOpen,
  projectNodeId,
  onRequestClose = () => {},
}) => {
  const { formatMessage } = useIntl();
  const projectId = parseInt(graphQLIdDecoder(projectNodeId)?.databaseId);

  const assetFilters = {
    assetType: FILTER_PHOTOS_ONLY,
    capturedAfter: null,
    capturedBefore: null,
    projects: [],
    users: [],
    groups: [],
    tags: [],
  };

  const handleSelection = (photos) => {
    if (editor) {
      // Insert gallery images
      photos.forEach((photo) => {
        const { url_large, url_small } = v1URLsFromAsset(photo);
        editor
          .chain()
          .insertPhoto({
            imageId: photo.databaseId,
            src: url_small,
            originalSrc: url_large,
            timestamp: photo.timestamp,
          })
          .run();
      });
    }
    onRequestClose();
  };

  return (
    <CCModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      label="Assets"
      size="large"
      showCloseButton
      headerStyle={{ borderBottomWidth: 0 }}
      bodyStyle={{ padding: 0, overFlow: 'hidden' }}
      title={formatMessage(messages.title)}
    >
      <Container>
        <AssetFeedContainer>
          <AssetFeed
            projectDatabaseId={projectId}
            entityId={projectNodeId}
            multiSelectHandlerComponent={
              <PickerFooter
                onSelection={handleSelection}
                onCancel={onRequestClose}
              />
            }
            isPresentedInModal
            initialFilters={assetFilters}
          />
        </AssetFeedContainer>
      </Container>
    </CCModal>
  );
};

PageAssetPickerModal.propTypes = {
  editor: PropTypes.object.isRequired,
  projectNodeId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default PageAssetPickerModal;
